import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const badgeVariants = cva(
  'inline-flex items-center px-2 py-0.5 font-label text-xs font-medium transition-colors',
  {
    variants: {
      variant: {
        default:     'bg-cmd-high text-primary',
        secondary:   'bg-cmd-highest text-cmd-outline',
        destructive: 'bg-cmd-error-container text-cmd-on-error',
        success:     'bg-[#003d20] text-[#80ffb4]',
        warning:     'bg-[#3d2e00] text-[#ffd080]',
        outline:     'border border-cmd-outline text-cmd-outline',
        critical:    'bg-cmd-error-container text-cmd-on-error font-semibold',
        high:        'bg-[#3d2e00] text-[#ffd080] font-semibold',
        normal:      'bg-cmd-highest text-cmd-outline',
        low:         'bg-cmd-high text-cmd-outline-variant',
      },
    },
    defaultVariants: { variant: 'default' },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />
}

export { Badge, badgeVariants }
